export default {
    heading: "變更登入二維碼",
    desc: "貴校如已選用教城簡易登入服務，您即可無須輸入密碼登入教城網頁。您亦可以在此檢視登入二維碼或刷新二維碼作登入教城之用。",
    createdAt: "刷新日",
    expireAt: "到期日",
    lostQrcode: "刷新/遺失二維碼",
    downloadQrcode: "下載登入二維碼",
    printQrcode: "列印登入二維碼",
    confirmRegenContent: "確定刷新登入二維碼?",
    confirm: "確定",
    cancel: "取消",
    noQrcodeDesc: "貴校如已選用教城簡易登入服務，您即可無須輸入密碼登入教城網頁。您亦可以在此檢視登入二維碼或刷新二維碼作登入教城之用。",
    noQrcode: "登入二維碼無效，請聯絡學校管理員刷新登入二維碼。",
}
